import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { StatusCliente } from "../../model/status.model";
import { NgbDropdownModule, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { StatusConfigService } from "../../services/status-config.service";
import { StatusConfigFormComponent } from "../status-message-form/status-config-form.component";
import { ConfirmationDialogService } from "src/app/shared/confirmation-dialog/confirmation-dialog.service";
import { AuthService } from "src/app/core/services/auth/auth.service";

@Component({
  selector: "app-status-message-list",
  templateUrl: "./status-message-list.component.html",
  styleUrl: "./status-message-list.component.scss",
})
export class StatusConfigListComponent implements OnInit {
  status: StatusCliente[] = [];
  isLoading: boolean = true;

  //permissão
  podeEditar: boolean = false;

  constructor(
    private statusConfigService: StatusConfigService,
    private modalService: NgbModal,
    private confirmationDialogService: ConfirmationDialogService,
    private authService: AuthService
  ) {}

  openNewStatusModal(status?: StatusCliente): void {
    const modalRef = this.modalService.open(StatusConfigFormComponent);
    if (status) {
      modalRef.componentInstance.status = status;
    }
    modalRef.closed.subscribe({
      next: () => {
        this.getStatusMessage();
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  ngOnInit(): void {
    this.permissaoAdicionarUsuario();

    this.getStatusMessage();
  }

  getStatusMessage() {
    this.isLoading = true;
    this.statusConfigService.getStatusMessages().subscribe({
      next: (status) => {
        this.status = status;
      },
      error: (error) => {
        console.error(error);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  onDeleteStatus(status: StatusCliente) {
    this.confirmationDialogService
      .confirm(
        "Confirma a exclusão do status?",
        "Essa ação não poderá ser desfeita.",
      )
      .then((confirmed) => {
        if (confirmed) {
          this.statusConfigService.deleteStatusMessage(status.id).subscribe({
            next: () => {
              this.getStatusMessage();
            },
            error: (error) => {
              console.error(error);
            },
          });
        }
      });
  }

  permissaoAdicionarUsuario(): void {
    this.podeEditar = this.authService.verificarPermissao('Call_Configuracoes', 'Editar')
  }
}
